
export default class FeaturedRoles {

	static getHolderSelectors = () => ['.featured-roles-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		let lastWindowSize = window.innerWidth;

		window.htmx.onLoad(target => {
			if (target.dataset.template === 'careers-featured-listing') {
				this.#resizeSlider();
				window.addEventListener('resize', (event) => {
					if ((lastWindowSize < 768 && window.innerWidth >= 768) || (lastWindowSize >= 768 && window.innerWidth < 768)) {
						lastWindowSize = window.innerWidth;
						this.#resizeSlider();
					}
				}, true);
			}
		});
	}

	#resizeSlider() {
		if (window.innerWidth < 768) {
			new Splide(this.#holderElement.querySelector('.splide'), {
				type: 'loop',
				gap: '0.75rem',
				padding: { left: '0.75rem'},
				width: '100vw',
				fixedWidth: 'calc(100vw - 1.5rem)',
				fixedHeight: '28.5rem',
				pagination: false,
			}).mount();
		} else {
			new Splide(this.#holderElement.querySelector('.splide'), {
				type: 'loop',
				gap: '3.5rem',
				padding: '18.6rem',
				fixedWidth: '38.5625rem',
				fixedHeight: '25.5rem',
				pagination: false,
			}).mount();
		}
	}

}
